export default "__VITE_ASSET__Thr8A4VJ__"